/* eslint-disable import/prefer-default-export */
import * as R from 'ramda';

// prettier-ignore
// isOptionEqualToValue :: String -> (a -> a) -> Bool
export const isOptionEqualToValue = prop => (option, value) => R.equals(
  R.propOr({}, prop, option), 
  R.propOr({}, prop, value)
);
